package de.oevbs.kunde.kundenportal2.model.services.registration

import de.oevbs.kunde.kundenportal2.RetrieveUserStep
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class RetrieveUser(
    val partner: String = "", // Benutzereingabe
    val user: String = "",    // Der Username, der zum Partner gefunden wurde (Rückgabe)
) {
    companion object {
        val validation =
            validation<RetrieveUser, RetrieveUserStep, ComponentValidationMessage> { inspector, progressStepId ->

                when (progressStepId) {
                    RetrieveUserStep.PARTNER1 -> {
                        val partner = inspector.map(RetrieveUser.partner())
                        if (partner.data.isEmpty()) {
                            add(partner.errorMessage(KupoValidationMessages.EMPTY_INPUT))
                        } else if (!Regexes.partnerId.matches(partner.data)) {
                            add(partner.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                        }
                    }

                    else -> println("Fehler - Unbekannter RetrieveUser Step im RetrieveUser Validator.")
                }
            }
    }
}